// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3wF5s","inner":"Form_inner__C-2LX","range":"Form_range__2H-gm","name":"Form_name__3Hpdg","actions":"Form_actions__3dUF2"};